<app-table-component [data]="reservationsList()" [columns]="tableColumns" [totalRecords]="totalRecords()" [rows]="rows"
    [first]="first" (pageChange)="onPageChange($event)" [tableName]="''" [searchControl]="searchControl"
                [showColumnSelector]="false"
                [showClearFilters]="false"
                searchPlaceholder="Reservation ID, customer, plate..." />
@defer (when cancelReservationDialog; prefetch on idle) {
<app-cancel-reservation-form (cancelledReservation)="onReservationCanceled()"
    [selectedReservation]="selectedReservation" [(visibility)]="cancelReservationDialog" />
}